<template>
  <div class="header-primary">
    <div class="container">
      <div class="col-lg-6 col-md-8 col-12">
        <div class="block mb-2 pt-3 pb-3 pl-3">
          <h1 class="m-0 md-headline font-weight-bolder text-white">{{title}}</h1>
          <h5 class="mt-0 md-subheading mb-0 text-white">{{subtitle}}</h5>
        </div>
      </div>
    </div>
    <div class="image">
      <div class="layer"></div>
      <img class="w-100" :src=image :alt=title>
    </div>
  </div>
</template>

<script>
import bgLineXBlack from "../assets/background/bg_line_x_black.jpg";

export default {
  name: "HeaderPrimary",
  props: {
    title: { default: "Title" },
    subtitle: { default: "Subtitulo" },
    image: { default: bgLineXBlack }
  }
};
</script>

<style scoped lang="scss">
.header-primary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  overflow: hidden;
  position: relative;
}

.container {
  z-index: 3;
}

.layer {
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(204, 0, 0, 0.87);
  mix-blend-mode: multiply;
}

.image {
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
}

.image img {
  z-index: 1;
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(3px) grayscale(100%);
}

.block {
  //border-radius: 1px;
  border: 1px solid #fff;
  background-color: rgba(127, 0, 0, 0.65);
}
</style>
